import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=f7f3adc4&scoped=true&"
import script from "./tip.vue?vue&type=script&lang=ts&"
export * from "./tip.vue?vue&type=script&lang=ts&"
import style0 from "./tip.vue?vue&type=style&index=0&id=f7f3adc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f3adc4",
  null
  
)

export default component.exports